import React from "react";
import { useQuery } from "@apollo/client";
import { GET_GRAPHIC_STAND } from 'graphql/query/graphic-stand-gql';
import { GET_GRAPHIC_PACKING_LIST } from 'graphql/query/graphic-packing-gql';
import { PageWrapDefault } from "components/layout";
import { useActiveMenuItem } from "components/use-hooks";
import GraphicStandRoute from 'components/routes/graphic-stands/graphic-stand-route';
import GraphicPacking from 'components/graphic-packing';
import { Localize } from "components/service";


const GraphicStandPage = ({ match, history }) => {


    useActiveMenuItem([ "stands" ], [ "stands" ]);

    const path = history.location.pathname.split('/').pop();
    const graphicPackingID = match ? parseInt(match.params.graphicPackingID) : null;
    const graphicStandID = match ? parseInt(match.params.graphicStandID) : null;

    const { data: { graphicList } = {}, loading: loadingGraphicPacking } = useQuery(GET_GRAPHIC_PACKING_LIST, {
        skip: !graphicPackingID,
        variables: {
            id: graphicPackingID
        }
    });


    const { data: { graphicStand } = {}, loading: loadingGraphicStand } = useQuery(GET_GRAPHIC_STAND, {
        skip: !graphicStandID,
        variables: {
            id: graphicStandID,
        },
        fetchPolicy: 'cache-and-network',
        nextFetchPolicy: 'cache-first'
    });

    const loading = path === 'create' ? false : loadingGraphicPacking || loadingGraphicStand;

    const pageNavbar = [
        {
            label: Localize({ children: "NAVBAR_PAGES.Label_Overview" }).props.children,
            path: "overview"
        },
    ];


    return (
        <PageWrapDefault
            className="page-graphic-stand"
            loading={ loading }
            title={ path === 'create' ? <Localize>PAGES.Title_CreateGraphicStand</Localize> : !loading && graphicStand ? graphicStand.exhibitor : 'Page 404' }
            dataExist={ path === 'create' ? true : !loading && graphicStand }
            pageNavbar={ !loading && graphicStand ? pageNavbar : false }
            staticPath={ `${ GraphicPacking.Const.basePath }/${ graphicPackingID }/stands/${ graphicStandID }` }
        >
            <GraphicStandRoute
                graphicPacking={ graphicList }
                graphicStand={ graphicStand }
                history={ history } />
        </PageWrapDefault>
    );
};

export default GraphicStandPage;





